import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from '../Boat.module.scss';
import metadata from './AdditionalPartsComponent.metadata.json5';
import AuxiliaryMotorsComponent from '../subcomponents/AuxiliaryMotors/AuxiliaryMotorsComponent';
import TenderDinghyBoatsComponent from '../subcomponents/TenderDinghyBoats/TenderDinghyBoatsComponent';
import DinghyMotorComponent from '../subcomponents/DinghyMotor/DinghyMotorComponent';
import TrailerComponent from '../subcomponents/Trailer/TrailerComponent';

function AdditionalPartsComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated, boatInformationPath, index } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('AdditionalPartsComponent');
    const modelVM = _.get(submissionVM, pathUpdated);

    modelVM.value.isValidationReq = true;

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        auxiliaryMotorsComponent: {
            id: `auxiliaryMotors${index}`,
            data: modelVM.auxiliaryMotorTable,
            updateWizardData,
            submissionVM,
            AuxiliaryMotorsPath: `${pathUpdated}.auxiliaryMotorTable`,
            boatInformationPath
        },
        tenderDinghyBoatsComponent: {
            id: `tenderDinghyBoats${index}`,
            data: modelVM.tenderDinghyBoatsTable,
            updateWizardData,
            submissionVM,
            TenderDinghyBoatsPath: `${pathUpdated}.tenderDinghyBoatsTable`,
            boatInformationPath
        },
        dinghyMotorComponent: {
            id: `dinghyMotor${index}`,
            data: modelVM.dinghyMotorTable,
            updateWizardData,
            submissionVM,
            DinghyMotorPath: `${pathUpdated}.dinghyMotorTable`,
            boatInformationPath
        },
        trailerComponent: {
            id: `trailer${index}`,
            data: modelVM.trailerTable,
            updateWizardData,
            submissionVM,
            TrailerPath: `${pathUpdated}.trailerTable`,
            boatInformationPath
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            auxiliaryMotorsComponent: AuxiliaryMotorsComponent,
            tenderDinghyBoatsComponent: TenderDinghyBoatsComponent,
            dinghyMotorComponent: DinghyMotorComponent,
            trailerComponent: TrailerComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={submissionVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

AdditionalPartsComponent.propTypes = wizardProps;
export default withRouter(AdditionalPartsComponent);
